export default "__VITE_ASSET__pV4xo4y9__"